import styled from "styled-components";
import { FlexMixin } from "../../../../styles/common/mixins/helpers.styled.js";
export const AccordionContainer = styled.div.withConfig({
    displayName: "styled__AccordionContainer",
    componentId: "sc-5451e8b6-0"
})`
	${FlexMixin({
    justify: 'center',
    direction: 'column'
})}
	padding-top: 4px;
	border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};
`;
export const AccordionHeader = styled.div.withConfig({
    displayName: "styled__AccordionHeader",
    componentId: "sc-5451e8b6-1"
})`
	${FlexMixin({
    justify: 'space-between',
    align: 'center'
})};
	cursor: pointer;
	padding-right: 13px;
`;
export const AccordionContent = styled.div.withConfig({
    displayName: "styled__AccordionContent",
    componentId: "sc-5451e8b6-2"
})`
	position: relative;
	overflow: auto;
	display: block;
	max-height: 800px;
	transform: translate(0);
	padding-top: 8px;
	z-index: ${({ theme  })=>theme.zIndex.lowest};
	width: 100%;
	transition: all 0.25s ease-in-out;

	&.is-hide {
		margin-top: 0;
		max-height: 0;
		display: none;
		transform: translateY(50%);
	}
`;

//# sourceMappingURL=styled.js.map